import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "anlie",
  style: {
    backgroundImage: 'url(http://www.zhuohuidacb.com/zrccss/honor_bg2_stop.jpg)'
  }
};
const _hoisted_3 = {
  class: "anlie_one"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  class: "anlie_two acea-row row-top"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  class: "anlie_thee acea-row row-top"
};
const _hoisted_11 = ["onMouseenter", "onClick"];
const _hoisted_12 = {
  class: "anlie_item_box_pic"
};
const _hoisted_13 = {
  class: "anlie_item_box acea-row row-bottom"
};
const _hoisted_14 = {
  key: 0,
  class: "anlie_item_box_btn acea-row row-center-wrapper"
};
const _hoisted_15 = {
  class: "anlie_item_box_yuyue"
};
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = {
  key: 1
};
const _hoisted_18 = {
  key: 1,
  class: "anlie_item_box_more"
};
const _hoisted_19 = {
  class: "anlie_item_box_title"
};
const _hoisted_20 = {
  class: "anlie_item_box_deso"
};
const _hoisted_21 = {
  key: 2,
  class: "anlie_item_box_txt"
};
const _hoisted_22 = {
  class: "aboubg",
  style: {
    backgroundImage: 'url(http://www.boyuyinuo.com/webcss/aboutbg.jpg)'
  }
};
const _hoisted_23 = {
  class: "about_one acea-row row-between-wrapper"
};
const _hoisted_24 = {
  class: "about_one_left acea-row row-between-wrapper"
};
const _hoisted_25 = {
  class: "about_one_item acea-row row-center-wrapper"
};
const _hoisted_26 = {
  class: "about_one_txt acea-row row-center-wrapper"
};
const _hoisted_27 = {
  key: 0
};
const _hoisted_28 = {
  key: 1
};
const _hoisted_29 = {
  class: "about_one_txt acea-row row-center-wrapper"
};
const _hoisted_30 = {
  key: 0
};
const _hoisted_31 = {
  key: 1
};
const _hoisted_32 = {
  class: "about_one_item acea-row row-center-wrapper"
};
const _hoisted_33 = {
  class: "about_one_txt acea-row row-center-wrapper"
};
const _hoisted_34 = {
  key: 0
};
const _hoisted_35 = {
  key: 1
};
const _hoisted_36 = {
  class: "about_one_txt acea-row row-center-wrapper"
};
const _hoisted_37 = {
  key: 0
};
const _hoisted_38 = {
  key: 1
};
const _hoisted_39 = {
  class: "about_one_item acea-row row-center-wrapper"
};
const _hoisted_40 = {
  class: "about_one_txt acea-row row-center-wrapper"
};
const _hoisted_41 = {
  key: 0
};
const _hoisted_42 = {
  key: 1
};
const _hoisted_43 = {
  class: "about_one_txt acea-row row-center-wrapper"
};
const _hoisted_44 = {
  key: 0
};
const _hoisted_45 = {
  key: 1
};
const _hoisted_46 = {
  class: "about_one_item acea-row row-center-wrapper"
};
const _hoisted_47 = {
  class: "about_one_txt acea-row row-center-wrapper"
};
const _hoisted_48 = {
  key: 0
};
const _hoisted_49 = {
  key: 1
};
const _hoisted_50 = {
  class: "about_one_txt acea-row row-center-wrapper"
};
const _hoisted_51 = {
  key: 0
};
const _hoisted_52 = {
  key: 1
};
const _hoisted_53 = {
  class: "about_one_right"
};
const _hoisted_54 = {
  class: "about_one_title acea-row row-between-wrapper"
};
const _hoisted_55 = {
  key: 0
};
const _hoisted_56 = {
  key: 1
};
const _hoisted_57 = {
  key: 0
};
const _hoisted_58 = {
  key: 1
};
const _hoisted_59 = {
  class: "about_one_deso acea-row row-top"
};
const _hoisted_60 = {
  key: 0
};
const _hoisted_61 = {
  key: 1
};
const _hoisted_62 = {
  class: "zixunall"
};
const _hoisted_63 = {
  class: "zixun"
};
const _hoisted_64 = {
  class: "zixun_one"
};
const _hoisted_65 = {
  key: 0
};
const _hoisted_66 = {
  key: 1
};
const _hoisted_67 = {
  class: "zixun_two"
};
const _hoisted_68 = {
  key: 0
};
const _hoisted_69 = {
  key: 1
};
const _hoisted_70 = {
  class: "zixun_three acea-row row-center-wrapper"
};
const _hoisted_71 = {
  key: 0
};
const _hoisted_72 = {
  key: 1
};
const _hoisted_73 = {
  key: 0
};
const _hoisted_74 = {
  key: 1
};
const _hoisted_75 = {
  key: 0
};
const _hoisted_76 = {
  key: 1
};
const _hoisted_77 = {
  key: 0
};
const _hoisted_78 = {
  key: 1
};
const _hoisted_79 = {
  class: "zixun_four acea-row row-between-wrapper"
};
const _hoisted_80 = {
  class: "zixun_four_left"
};
const _hoisted_81 = ["onClick"];
const _hoisted_82 = {
  class: "zixun_tuijian_one"
};
const _hoisted_83 = {
  class: "zixun_tuijian_two acea-row row-between-wrapper"
};
const _hoisted_84 = {
  class: "zixun_tuijian_time"
};
const _hoisted_85 = {
  class: "zixun_tuijian_daytxt"
};
const _hoisted_86 = {
  class: "zixun_tuijian_yeartxt"
};
const _hoisted_87 = {
  class: "zixun_tuijian_txt"
};
const _hoisted_88 = {
  class: "zixun_tuijian_title"
};
const _hoisted_89 = {
  key: 0
};
const _hoisted_90 = {
  key: 1
};
const _hoisted_91 = {
  class: "zixun_tuijian_deso"
};
const _hoisted_92 = {
  key: 0
};
const _hoisted_93 = {
  key: 1
};
const _hoisted_94 = {
  class: "zixun_four_right"
};
const _hoisted_95 = ["onClick"];
const _hoisted_96 = {
  class: "zixun_news_time"
};
const _hoisted_97 = {
  class: "zixun_news_daytxt"
};
const _hoisted_98 = {
  class: "zixun_news_yeartxt"
};
const _hoisted_99 = {
  class: "zixun_news_txt"
};
const _hoisted_100 = {
  class: "zixun_news_title"
};
const _hoisted_101 = {
  key: 0
};
const _hoisted_102 = {
  key: 1
};
const _hoisted_103 = {
  class: "zixun_news_deso"
};
const _hoisted_104 = {
  key: 0
};
const _hoisted_105 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_zrcheader = _resolveComponent("zrcheader");
  const _component_el_image = _resolveComponent("el-image");
  const _component_swiper_slide = _resolveComponent("swiper-slide");
  const _component_swiper = _resolveComponent("swiper");
  const _component_zrcfooter = _resolveComponent("zrcfooter");
  const _component_loading = _resolveComponent("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_zrcheader, {
    xzmenu: $data.xzmenu,
    xzlag: $data.xzlag
  }, null, 8, ["xzmenu", "xzlag"]), _createVNode(_component_swiper, {
    "slides-per-view": 1,
    modules: $setup.modules,
    autoplay: "true",
    navigation: "",
    pagination: {
      clickable: true
    },
    style: {
      "height": "850px",
      "width": "100%"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_swiper_slide, null, {
      default: _withCtx(() => [$data.xzlag == 1 ? (_openBlock(), _createBlock(_component_el_image, {
        key: 0,
        src: "http://www.boyuyinuo.com/webcss/banner_en.jpg"
      })) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createBlock(_component_el_image, {
        key: 1,
        src: "http://www.boyuyinuo.com/webcss/banner_cn.jpg"
      })) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_swiper_slide, null, {
      default: _withCtx(() => [$data.xzlag == 1 ? (_openBlock(), _createBlock(_component_el_image, {
        key: 0,
        src: "http://www.boyuyinuo.com/webcss/banner_en.jpg"
      })) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createBlock(_component_el_image, {
        key: 1,
        src: "http://www.boyuyinuo.com/webcss/banner_cn.jpg"
      })) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_swiper_slide, null, {
      default: _withCtx(() => [$data.xzlag == 1 ? (_openBlock(), _createBlock(_component_el_image, {
        key: 0,
        src: "http://www.boyuyinuo.com/webcss/banner_en.jpg"
      })) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createBlock(_component_el_image, {
        key: 1,
        src: "http://www.boyuyinuo.com/webcss/banner_cn.jpg"
      })) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }, 8, ["modules"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_4, "PRODUCT")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_5, "产品中心")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.cate_list, (item_cateson, index_cateson) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass([$data.cate_jiance_id == item_cateson.id ? 'cidjiacu' : 'cidzhengchang']),
      onClick: $event => $options.SelectCateSonId(item_cateson.id, 3)
    }, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item_cateson.cate_name_en), 1)) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item_cateson.cate_name), 1)) : _createCommentVNode("", true)], 10, _hoisted_7);
  }), 256))]), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.anli_list, (item_project, index_project) => {
    return _openBlock(), _createElementBlock("div", {
      class: "anlie_item",
      onMouseenter: $event => $options.handleMouseEnter(item_project.id),
      onMouseleave: _cache[0] || (_cache[0] = $event => $options.handleMouseLeave()),
      onClick: $event => $options.goprojectdetail(item_project.id, 1)
    }, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_image, {
      src: item_project.image,
      class: "anlie_item_box_el_image"
    }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_13, [$data.xzfwid == item_project.id ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_16, "SEE MORE")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_17, "立即查看")) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), $data.xzfwid == item_project.id ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(item_project.title), 1), _createElementVNode("div", _hoisted_20, _toDisplayString(item_project.deso), 1)])) : _createCommentVNode("", true), $data.xzfwid != item_project.id ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(item_project.title), 1)) : _createCommentVNode("", true)])], 40, _hoisted_11);
  }), 256))])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", null, [_createVNode(_component_el_image, {
    src: "http://www.boyuyinuo.com/webcss/foot_ico1.png",
    fit: "none"
  })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_26, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_27, "SERVICE")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_28, "全程服务")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_29, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_30, "Response within 24 hours")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_31, "售前咨询，下单24小时内响应，关键环节100%提醒")) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", null, [_createVNode(_component_el_image, {
    src: "http://www.boyuyinuo.com/webcss/foot_ico2.png",
    fit: "none"
  })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_33, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_34, "ASSURANCE")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_35, "品质保障")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_36, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Operated by professionals")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_38, "所有产品保证服务质量由专业人士进行操作")) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", null, [_createVNode(_component_el_image, {
    src: "http://www.boyuyinuo.com/webcss/foot_ico3.png",
    fit: "none"
  })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_40, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_41, "DELIVERD")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_42, "安全送达")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_43, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_44, "Fast customs clearance, international logistics")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_45, "快速通关，国际物流")) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", null, [_createVNode(_component_el_image, {
    src: "http://www.boyuyinuo.com/webcss/foot_ico4.png",
    fit: "none"
  })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_47, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_48, "CONFIDENTINLITY")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_49, "信息保密")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_50, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_51, "All customer information is strictly kept confidential to prevent any leakage")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_52, "客户所有信息严格保密保,免遭外泄")) : _createCommentVNode("", true)])])])]), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("div", null, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_55, "ABOUT US")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_56, "企业介绍")) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: "about_one_more acea-row row-top",
    onClick: _cache[1] || (_cache[1] = $event => $options.goxinwen(1, 7))
  }, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_57, "MORE>>")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_58, "了解详情>>")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_59, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_60, " Chengdu Baiyu Yinuo Technology Co., Ltd. is a national high-tech enterprise that continuously focuses on the research, development, manufacturing, sales, and service of inverter welding and cutting equipment, welding automation series products, welding accessories, and protective equipment.")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_61, [...(_cache[6] || (_cache[6] = [_createTextVNode(" 成都柏宇亿诺科技有限公司是一家持续专注于逆变焊割设备、焊接自动化系列产品、焊接配件、防护用品的研发、制造、销售及服务的国家高新技术企业 ", -1), _createElementVNode("br", null, null, -1), _createTextVNode(" 主营逆变直流手工弧焊机、逆变氩弧焊机、逆变气体保护焊机、逆变空气等离子切割机、手持激光焊机、机器人焊接系统集成、自动化焊接小车、数字化智能焊接设备、高效焊接系统、焊接和切割配件、焊接防护用品等产品。 ", -1)]))])) : _createCommentVNode("", true)])])])]), _createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_65, "NEWS")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_66, "平台资讯")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_67, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_68, "We will update the news and share it with you as soon as possible")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_69, "我们会第一时间更新动态，分享给您们")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_70, [_createElementVNode("div", {
    class: _normalizeClass(["zixun_three_item", [$data.xznewcid == 1 ? 'zixunbg' : '']]),
    onClick: _cache[2] || (_cache[2] = $event => $options.selecetnewcid(1))
  }, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_71, "INDUSTRY")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_72, "行业动态")) : _createCommentVNode("", true)], 2), _createElementVNode("div", {
    class: _normalizeClass(["zixun_three_item", [$data.xznewcid == 2 ? 'zixunbg' : '']]),
    onClick: _cache[3] || (_cache[3] = $event => $options.selecetnewcid(2))
  }, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_73, "NEWS")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_74, "公司新闻")) : _createCommentVNode("", true)], 2), _createElementVNode("div", {
    class: _normalizeClass(["zixun_three_item", [$data.xznewcid == 3 ? 'zixunbg' : '']]),
    onClick: _cache[4] || (_cache[4] = $event => $options.selecetnewcid(3))
  }, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_75, "HELP")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_76, "常见问题")) : _createCommentVNode("", true)], 2), _createElementVNode("div", {
    class: _normalizeClass(["zixun_three_item", [$data.xznewcid == 6 ? 'zixunbg' : '']]),
    onClick: _cache[5] || (_cache[5] = $event => $options.selecetnewcid(6))
  }, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_77, "ABOUT")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_78, "关于我们")) : _createCommentVNode("", true)], 2)]), _createElementVNode("div", _hoisted_79, [_createElementVNode("div", _hoisted_80, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsone_list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "zixun_tuijian",
      onClick: $event => $options.goxinwen(item.id, 5)
    }, [_createElementVNode("div", _hoisted_82, [_createVNode(_component_el_image, {
      class: "zixun_tuijian_image",
      src: item.image_input
    }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_83, [_createElementVNode("div", _hoisted_84, [_createElementVNode("div", _hoisted_85, _toDisplayString(item.daytxt), 1), _createElementVNode("div", _hoisted_86, _toDisplayString(item.yeartxt), 1)]), _createElementVNode("div", _hoisted_87, [_createElementVNode("div", _hoisted_88, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_89, _toDisplayString(item.share_title), 1)) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_90, _toDisplayString(item.title), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_91, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString(item.share_deso), 1)) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_93, _toDisplayString(item.deso), 1)) : _createCommentVNode("", true)])])])], 8, _hoisted_81);
  }), 256))]), _createElementVNode("div", _hoisted_94, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.news_list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "zixun_news acea-row row-between-wrapper",
      onClick: $event => $options.goxinwen(item.id, 5)
    }, [_createElementVNode("div", _hoisted_96, [_createElementVNode("div", _hoisted_97, _toDisplayString(item.daytxt), 1), _createElementVNode("div", _hoisted_98, _toDisplayString(item.yeartxt), 1)]), _createElementVNode("div", _hoisted_99, [_createElementVNode("div", _hoisted_100, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_101, _toDisplayString(item.share_title), 1)) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_102, _toDisplayString(item.title), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_103, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_104, _toDisplayString(item.share_deso), 1)) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_105, _toDisplayString(item.deso), 1)) : _createCommentVNode("", true)])])], 8, _hoisted_95);
  }), 256))])])])]), _createVNode(_component_zrcfooter, {
    xzlag: $data.xzlag
  }, null, 8, ["xzlag"]), _createVNode(_component_loading, {
    status: $data.loadingStatus
  }, null, 8, ["status"])]);
}